import React from "react";
import { PortfolioHeroWrap } from "./PortfolioHero.styled";

const PortfolioHero = () => {
  return (
    <section>
      <PortfolioHeroWrap>
        <div>
          <h2>Portfolio Standard</h2>
        </div>
      </PortfolioHeroWrap>
    </section>
  );
};

export default PortfolioHero;
